import TableAHSF from "../../Components/TableAHSF"
import PopupAHSF from "../../Components/PopupAHSF"
import './style.css'
import Swal from "sweetalert2"
import { useDispatch, useSelector } from "react-redux"

import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { decryptToken } from "../../Services/Account/EncryptionParams"
import { GetReportByAppGuid } from "../../Redux/Reducers/ReportStage/Report"
import AddObjectivesProject from "./AddObjectivesProject"
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables"
import { DeleteObjectiveProjects } from "../../Redux/Reducers/ReportStage/Objective"


const ObjectivesProject = () => {
    const dispatch = useDispatch()
    const [objectiveProjectsId, setObjectiveProjectsId] = useState(null)
    const [PopupComponentEditStatus, setPopupComponentEditStatus] =
        useState(false);
    const reports = useSelector((state) => state.ReportByAppGuidReducers.ReportByApp)
    const addObjectives = useSelector((state) => state.ObjectiveReducer.addObjective)
    const DeleteObjectives = useSelector((state) => state.ObjectiveReducer.DeleteObjective)
    const editObjectives = useSelector((state) => state.ObjectiveReducer.updataObjective)


    const tokens = useParams().token
    const [appGuid, setAppGuid] = useState(null)
    // console.log(decryptToken(tokens),"sdlskdlskdd");

    useEffect(() => {


        if (tokens) {
            var token = decryptToken(tokens)
            console.log(token,"sdsdssssssssssssssssssssdd");
            
            setAppGuid(token)
            // console.log(token,"sdkjskijdsiiisd");

        }

    }, [])
    useEffect(() => {
        dispatch(GetReportByAppGuid({ aI_ApplicationInformationId: appGuid }))

    }, [appGuid])
    console.log(reports?.
        pR_ReportsId, "Sdsdsdsdsdsdsd");


    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });
    const culomEdite = ["email", "fullName"];
    const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
    const RequestsColumns = [];

    const RequestAccessor = [
        {
            KeyName: "objectiveName",
            ShowStatus: true,
            NmaeColumn: "الهدف",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },

    ];
    console.log(reports, "slkdlskdlksdkl");

    const OtherMainBtns = [


        {
            Click: async (e) => {
                Swal.fire({
                    title: state.jsonData.deleteTitlePopUp?.nameAR,
                    icon: "error",
                    // iconHtml: "؟",
                    confirmButtonText: "تأكيد",
                    cancelButtonText: "الغاء",
                    showCancelButton: true,
                    showCloseButton: true,
                }).then((res) => {
                    if (res.isConfirmed == true) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تم الحذف بنجاح",
                            showConfirmButton: false,
                            timer: 1500,
                            // width: "500px",
                        });

                        dispatch(DeleteObjectiveProjects({ pR_ObjectiveProjectsId: e.target.value }))

                    }
                });
            },
            content: "",
            className: "bi bi-trash",
            id: "deleteBtn",
            title: "حذف",
            ShowStatus: true,
        },
        {
            Click: async (e) => {
                setObjectiveProjectsId(e.target.value)
                closePopupEditComponent()
            },
            content: "",
            className: "bi bi-pencil-square",
            id: "editBtn",
            title: "تعديل",
            ShowStatus: true,
        },

    ];
    const PopupOPjectData = {
        isPopupOpenStatus: true,
        isPopupOpenFunction: () => { },
        componentBody: <AddObjectivesProject />,
        maxWidth: "500px",
        maxHeight: "800px",
        title: "الأهداف",
    };
console.log(addObjectives,"sdsdsdwwwwwwwwdwd");

    useEffect(() => {
        dispatch(setRefreshTable());
    }, [addObjectives,DeleteObjectives,editObjectives])


    const closePopupEditComponent = () => {
        if (PopupComponentEditStatus) {
            setPopupComponentEditStatus(false);
        } else {
            setPopupComponentEditStatus(true);
        }
    };

    return (

        <>
            {
                reports ? <TableAHSF
                    culomEdite={culomEdite}
                    uniqueValue={"pR_ObjectiveProjectsId"}
                    valueButtonAction={"pR_ObjectiveProjectsId"}
                    URL={`api/PR_ReportsStages/GetObjectiveProjectsList`}
                    UrlBody={{
                        pR_ReportsId: reports?.pR_ReportsId,
                    }}
                    staticKeyEdite={staticKeyEdite}
                    accessor={RequestAccessor}
                    titelTable={""}
                    selectRowNumber={true}
                    checkBoksColumName="اختيار"
                    sort={true}
                    pagination={true}
                    AppStatus={true}
                    tableBtn={true}
                    sortTable={true}
                    keyNameSort={"dateCreate"}
                    dateKey="dateCreate"
                    dateformat="DD/MM/YYYY h:mm a"
                    arrayNameSort={["applicationNumber"]}
                    search={true}
                    openPopupState={false}
                    DropdownArrayFiltration={[]}
                    DropdownFiltration={false}
                    exportData={true}
                    checkBoks={false}
                    nameColumAction=""
                    total={false}
                    arrayButton={OtherMainBtns}
                    ArrayNameDataColum={RequestsColumns}
                    columnKeyNameArray={[
                        { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                    ]}
                    PopupOPjectData={PopupOPjectData}
                    popUpTitle={"معلومات الطلب"}

                /> : <></>
            }

            <PopupAHSF
                title={"الأهداف"}
                componentBody={
                    <AddObjectivesProject objectiveProjectsId={objectiveProjectsId} statusAction={"edit"} />
                }
                maxWidth="700px"
                maxHeight="800px"
                isPopupOpenStatus={PopupComponentEditStatus}
                isPopupOpenFunction={closePopupEditComponent}
            />

            <PopupAHSF
                title={"الأهداف"}
                componentBody={
                    <></>

                }
                maxWidth="700px"
                maxHeight="800px"
                isPopupOpenStatus={false}
                isPopupOpenFunction={false}
            />

        </>
    )
}


export default ObjectivesProject